import { createBrowserHistory } from 'history'
import type { VisibleLanguageOption } from 'i18n/util/locale'
import { pathnameHasRegionCode } from 'lib/string/regionUtils'
import { buildUrl } from 'lib/url/searchUrlUtils'

function initialiseHistory(regionCode: string, locale?: string, languageOptions?: Array<VisibleLanguageOption>) {
  const history = createBrowserHistory()
  // Trust the SSR region code, if the region code isn't in the url - replace it in
  if (!pathnameHasRegionCode(history.location.pathname, regionCode)) {
    const nextLocation = { ...history.location }
    nextLocation.pathname = buildUrl(nextLocation.pathname, regionCode, undefined, undefined, { locale, languageOptions })
    history.replace(nextLocation)
  }

  return history
}

export default initialiseHistory
